import React, { useState } from 'react';

import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { SupportedThirdParty } from '../../../common/constants/import-type';
import { FieldMappingItemTypeContext } from '../../../common/utils/field-mapping-item-type-context';
import { useThirdPartyFieldsItemTypes } from '../../../controllers/import-state';
import { FieldsMappingContentWithTabs } from './fields-mapping-content';
import { FieldsMappingHeader } from './fields-mapping-header';

type Props = {
	thirdParty: SupportedThirdParty;
	rowsPerPage?: number;
};

export const FieldsMapping = (props: Props) => {
	const { thirdParty } = props;
	const [itemTypes] = useThirdPartyFieldsItemTypes();

	const [itemType, setItemType] = useState<string | null>(itemTypes[0] || null);

	return (
		<FieldMappingItemTypeContext.Provider value={itemType}>
			<Wrapper data-testid="project-create-importer-upload-flow.ui.third-party-review-screen.fields-mapping.wrapper">
				<FieldsMappingHeader thirdParty={thirdParty} />
				<FieldsMappingContentWithTabs
					{...props}
					itemTypes={itemTypes}
					onItemTypeChanged={(type: string) => {
						setItemType(type);
					}}
					selectedItemType={itemType}
				/>
			</Wrapper>
		</FieldMappingItemTypeContext.Provider>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexFlow: 'column',
	width: '100%',
	boxSizing: 'border-box',
	padding: `${token('space.300', '24px')} ${token('space.100', '8px')}`,
});
